
import IFeature from "./IFeature";
import IFeatureController from "./IFeatureController";
import VideoRecorder from "./VideoRecorder";
import GroundPlacement from "./GroundPlacement";

export default class FeatureRegistry {
  private features: Map<string, IFeature> = new Map();

  public constructor() {
    this.populateFeatures();
  }

  public getFeatures(): IFeature[] {
    return Array.from(this.features.values());
  }

  public getFeatureUIs(): any[] {
    return this.getFeatures()
      .map(f => f.ui)
      .filter(Boolean);
  } 

  public getFeatureControllers(): (new (app: any) => IFeatureController)[] {
    return this.getFeatures()
      .map(f => f.controller)
      .filter(Boolean);
  }

  private populateFeatures(): void {
    // Add features to the registry here
    this.features.set("videoRecorder", new VideoRecorder());
    this.features.set("groundPlacement", new GroundPlacement());
  }
}